export const Constant = {
  IN_COOKIE_TOKEN_NAME: {
    RL_ACCESS: "rlAccessToken",
    RL_REFRESH: "rlRefreshToken",
    KBB_ACCESS: "accessToken",
    KBB_REFRESH: "refreshToken",
    VALIDATED_KBB_TOKEN: "rl_valid_kbb_token",
  },
  DEEPLINK: {
    BASE_URL: "https://ad.kyobo.com/api/v1/click/6ItTAomK5Eu64HVPJv6wNw",
    DEEPLINK_SCHEME: "dgtapp://deeplink/dgt/web/dtm/haru/readlog",
    ADV_CAMPAIGN: "library",
    ADV_ADGROUP: "share",
    TRACKER_ID: "6ItTAomK5Eu64HVPJv6wNw",
  },
}

export const BOTTOM_GNB_HEIGHT: number = 54

export const UNIVERSAL_LINK_STORE_URL: string =
  "https://ad.kyobo.com/api/v1/click/6ItTAomK5Eu64HVPJv6wNw?deeplink_custom_path=dgtapp://deeplink/dgt/web/dtm/haru/readlog%3FreadLogLink%3D%252F&adv_campaign=library"
